export default __webpack_public_path__ + "static/NotoSans-Bold-23e70cfbbe0783c668041d62e24b6cae.ttf";